// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.table-container[data-v-05e16f9e]{ padding : 0 5px\n}\n.custom-element-table[data-v-05e16f9e]{ position: relative;\n}\n", ""]);
// Exports
module.exports = exports;
